//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";

// ⭐ ต้องตรงกับเงื่อนไขฝั่ง backend (account2.repository.js / setting_menu_detail_q.repository.js)
// กลุ่มสิทธิ์ที่ชื่อ "System Admin" ของ Company นี้เท่านั้น ถึงจะเป็น Super Admin ข้ามบริษัทได้
const SUPER_ADMIN_COMPANY_ID = 1;

export default {
  name: "access-control",
  data: () => ({
    dialog: false,
    search: "",
    dialogDelete: false,
    dialogEdit: false,
    dialogAdd: false,
    text_color: "text-h5 green--text text-center",
    title: "green",
    message: "green",
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Name", value: "sgm_name" },
      { text: "Company", value: "company_name" }, // ⭐ ใหม่: โชว์ว่ากลุ่มสิทธิ์นี้เป็นของบริษัทไหน
      { text: "Actions", value: "actions", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      sgm_name: "",
      company_id: 0,
      department_id: 0,
      status: "ACTIVE",
      user_create: 0,
      user_update: 0,
    },
    dataItemedit: {
      sgm_name: "",
      company_id: 0,
      department_id: 0,
      status: "ACTIVE",
      user_create: 0,
      user_update: 0,
    },
    editedItem2: {
      sgm_name: "",
      company_id: localStorage.getItem(server.COMPANYID),
      user_update: 0,
    },
    edit_item_id: 0,
    defaultItem: {
      sgm_name: "",
      company_id: localStorage.getItem(server.COMPANYID),
      user_create: 0,
      user_update: 0,
    },
    setting_menu_detail: {
      setting_group_menu_id: 0,
      group_menu_id: 0,
      menu_detail_id: 0,
      company_id: localStorage.getItem(server.COMPANYID),
      user_create: 0,
    },
    fullPage: true,
    checkDataLoop: false,
    mArrayInsertMenuDetail: [],
    authorize_view: false,
    authorize_add: false,
    authorize_edit: false,
    authorize_del: false,
    authorize_id: 0,
    companyAll: [],
    departmentlist: [],
    statusall: ["ACTIVE", "INACTIVE"],
    isSuperAdmin: false, // ⭐ ใหม่: true เมื่อกลุ่มสิทธิ์ของผู้ใช้ชื่อ "System Admin" ของ Company = 1 เท่านั้น
  }),
  components: {
    SuccessDialog,
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Authorize" : "Edit Authorize";
    },
  },
  async mounted() {
    await api.checkVersion();
    // this.$showLoader();
    this.$hideLoader();
    // ----------------- Check Authorize ---------------------------
    const userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogEdit(val) {
      val || this.closeedit();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async created() {
    // ⭐ ใหม่: ต้องเช็คว่าเป็น Super Admin หรือไม่ "ก่อน" โหลดรายชื่อบริษัท/รายการกลุ่มสิทธิ์
    // เพราะ loadCustomer() และ initialize() ใช้ค่า this.isSuperAdmin ตัดสินใจว่าจะดึง
    // ข้อมูลแค่บริษัทตัวเอง หรือดึงข้อมูลทุกบริษัท
    await this.checkSuperAdmin();
    await this.loadCustomer();
    await this.initialize();
  },

  methods: {
    // ⭐ แก้ไข: เช็คว่าผู้ใช้อยู่กลุ่มสิทธิ์ "System Admin" ของ Company = 1 เท่านั้น
    // (เดิมเช็คแค่ชื่อ ตอนนี้เพิ่มเช็ค company_id ด้วย เพื่อกันกรณีมีคนตั้งชื่อกลุ่ม
    // "System Admin" ซ้ำที่บริษัทอื่นในอนาคตแล้วได้สิทธิ์ Super Admin ไปโดยไม่ตั้งใจ)
    async checkSuperAdmin() {
      try {
        const authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
        const res_sgm = await api.getSettingGroupMenu_ById(authorize_id);
        const sgmRow = res_sgm.data && res_sgm.data[0];
        const isNameMatch =
          !!sgmRow &&
          String(sgmRow.sgm_name || "")
            .trim()
            .toUpperCase() === "SYSTEM ADMIN";
        const isCompanyMatch =
          !!sgmRow && Number(sgmRow.company_id) === SUPER_ADMIN_COMPANY_ID;

        this.isSuperAdmin = isNameMatch && isCompanyMatch;
      } catch (e) {
        console.error("checkSuperAdmin error:", e);
        this.isSuperAdmin = false;
      }
    },

    // ⭐ แก้ไข: Super Admin ต้องเห็น dropdown "Company" เป็นทุกบริษัท ไม่ใช่แค่บริษัทตัวเอง
    async loadCustomer() {
      if (this.isSuperAdmin) {
        const result = await api.getAllCompany();
        this.companyAll = result.data;
      } else {
        const result = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );
        this.companyAll = result.data;
      }
    },

    // ⭐ ใหม่: หาชื่อบริษัทจาก company_id ใช้กับคอลัมน์ Company ในตาราง
    getCompanyName(company_id) {
      const found = (this.companyAll || []).find(
        (c) => String(c.id) === String(company_id),
      );
      return found ? found.name : company_id;
    },

    async changeCompany() {
      const result = await api.getNewAllDepartment_By_CompanyID(
        this.editedItem.company_id,
      );

      this.departmentlist = result.data;
    },

    // ⭐ แก้ไข: Super Admin เห็นรายการกลุ่มสิทธิ์ของทุกบริษัท ไม่ใช่แค่บริษัทตัวเอง
    async initialize() {
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      var res_get;

      res_get = await api.getSettingGroupMenu_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );
      // if (this.isSuperAdmin) {
      //   res_get = await api.getSettingGroupMenu(); // unscoped - ทุกบริษัท
      // } else {
      //   res_get = await api.getSettingGroupMenu_By_CompanyID(
      //     localStorage.getItem(server.COMPANYID),
      //   );
      // }

      // ⭐ ใหม่: แนบชื่อบริษัทไปกับแต่ละแถว เพื่อโชว์ในคอลัมน์ Company
      this.desserts = (res_get.data || []).map((row) => ({
        ...row,
        company_name: this.getCompanyName(row.company_id),
      }));

      loader.hide();
      //   console.log("initialize desserts: " + JSON.stringify(res_get.data));
    },

    async editItemAut(item) {
      const result = await api.getNewAllDepartment_By_CompanyID(
        item.company_id,
      );
      this.departmentlist = result.data;

      this.dialogEdit = true;
      this.dataItemedit = item;
    },

    // ⭐ แก้ไข: เดิมล็อกใช้ localStorage.COMPANYID (บริษัทที่ login อยู่) เสมอ ทำให้ตอน
    // Super Admin แก้ไขกลุ่มสิทธิ์ของบริษัทอื่น ไปหยิบ "master เมนู" ผิดบริษัทมาผูก
    // ทำให้เกิดข้อมูลเพี้ยนข้ามบริษัทได้ ตอนนี้ใช้ company_id ของกลุ่มสิทธิ์ที่กำลัง
    // แก้ไข (item.company_id) แทนเสมอ
    async editItem(item) {
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      this.edit_item_id = item.id;
      //   this.editedIndex = this.desserts.indexOf(item);
      //   this.editedItem = Object.assign({}, item);
      //   this.dialog = true;
      // Go To Setting Menu Detail

      const res_main_for_check = await api.getMenuDetail_By_CompanyId(
        item.company_id, // ⭐ แก้ไข (เดิม: localStorage.getItem(server.COMPANYID))
      );

      const res_check = await api.getSMD_ById(item.id);

      if (res_check.data.count < res_main_for_check.data.count) {
        this.setting_menu_detail.user_create = localStorage.getItem(
          server.USER_ID,
        );
        this.setting_menu_detail.company_id = item.company_id; // ⭐ แก้ไข (เดิม: localStorage.COMPANYID)

        this.mArrayInsertMenuDetail = res_main_for_check.data.rows;

        // Start Loop Check Data
        for (let i = 0; i < res_main_for_check.data.count; i++) {
          this.checkDataLoop = false;
          console.log("Loop Data: " + this.mArrayInsertMenuDetail[i].id);
          this.setting_menu_detail.setting_group_menu_id = item.id;
          this.setting_menu_detail.group_menu_id = this.mArrayInsertMenuDetail[
            i
          ].group_menu_id;
          this.setting_menu_detail.menu_detail_id = this.mArrayInsertMenuDetail[
            i
          ].id;

          for (let j = 0; j < res_check.data.count; j++) {
            if (
              this.setting_menu_detail.menu_detail_id ==
              res_check.data.rows[j].menu_detail_id
            ) {
              this.checkDataLoop = true;
            }
            if (this.checkDataLoop == true) {
              break;
            }
          }

          if (this.checkDataLoop == false) {
            const res_add_stdt = await api.createSettingMenuDetail(
              this.setting_menu_detail,
            );
            // console.log("Loop Data " + i + ":" + res_add_stdt.status);
          }
        }
        // End Loop Check Data
        loader.hide();
        this.$router.push(`/setting-menu-detail/${item.id}`);
      } else {
        loader.hide();
        this.$router.push(`/setting-menu-detail/${item.id}`);
      }
    },

    deleteItem(item) {
      this.edit_item_id = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      const res_del = await api.deleteSettingGroupMenu(this.edit_item_id);
      if (res_del.status == 200) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Delete data success",
          "text-h5 green--text text-center",
        );
        this.initialize();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Delete data Failed",
          "text-h5 red--text text-center",
        );
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeedit() {
      this.dialogEdit = false;
      this.departmentlist = [];
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async saveedit() {
      if (
        this.dataItemedit.sgm_name == "" ||
        this.dataItemedit.company_id == 0 ||
        this.dataItemedit.department_id == 0 ||
        !this.dataItemedit.department_id ||
        this.dataItemedit.status == "" ||
        !this.dataItemedit.status
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter all the details.",
          "text-h5 red--text text-center",
        );
        return;
      }

      var dataedit = {
        sgm_name: this.dataItemedit.sgm_name,
        company_id: Number(this.dataItemedit.company_id),
        department_id: Number(this.dataItemedit.department_id),
        status: this.dataItemedit.status,
        user_update: Number(localStorage.getItem(server.USER_ID)),
      };
      this.$showLoader();
      const res_edit = await api.updateSettingGroupMenu(
        Number(this.dataItemedit.id),
        dataedit,
      );
      if (res_edit.status == 200) {
        this.closeedit();
        await this.initialize();
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Success",
          "Edit data success",
          "text-h5 green--text text-center",
        );
        this.initialize();
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Add data Failed",
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ แก้ไข: เดิมบังคับเขียนทับ company_id เป็นบริษัทที่ login อยู่เสมอ ทำให้ต่อให้
    // Super Admin เลือกบริษัทอื่นในฟอร์ม ก็ยังจะไปสร้างให้บริษัทตัวเองอยู่ดี
    // ตอนนี้ Super Admin จะใช้ company_id ที่เลือกไว้ในฟอร์มแทน ส่วนผู้ใช้ทั่วไปยัง
    // ถูกล็อกเป็นบริษัทตัวเองเหมือนเดิมเพื่อความปลอดภัย
    async save() {
      if (this.editedIndex > -1) {
        // Go To Setting Menu Detail
      } else {
        // alert("create");
        if (
          this.editedItem.sgm_name == "" ||
          this.editedItem.company_id == 0 ||
          this.editedItem.department_id == 0 ||
          this.editedItem.status == ""
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter all the details.",
            "text-h5 red--text text-center",
          );
          return;
        }

        if (!this.isSuperAdmin) {
          this.editedItem.company_id = localStorage.getItem(server.COMPANYID);
        }
        // ถ้าเป็น Super Admin จะไม่เขียนทับ company_id ตรงนี้ - ใช้ค่าที่เลือกใน dropdown

        this.editedItem.user_create = localStorage.getItem(server.USER_ID);
        const res_add = await api.createSettingGroupMenu(this.editedItem);
        if (res_add.status == 200) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Success",
            "Add data success",
            "text-h5 green--text text-center",
          );
          this.initialize();
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Add data Failed",
            "text-h5 red--text text-center",
          );
        }
      }

      this.close();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
